import React, { Component } from 'react';
import {
    LoadingComponent,
    PageListComponent,
    HeaderListComponent,
    FormActionComponent,
} from "../../../common/component/Index";
import i18n from "../../../../../constants/initLng";
import DEFINE, 
    { 
        PATHS, UPLOAD_DIRECTORY, TOUR_TABS, VALIDATE_ENUM, DETAIL_ACTIONS, 
        FEATURE_FLAGS, 
        CAMPAIGN as CAMPAIGN_ENUM
    } from "../../../../../constants/Define";
import { message } from 'antd';
import _, { isEqual, find, get, clone, cloneDeep, toArray, uniqBy, isEmpty } from 'lodash';
import * as Func from '../../../../../helpers/functions';
import Tour, { TourImage, TourLine } from '../../../../../models/Tour';
// import Modal from '../../../common/component/Modal';
import { Modal } from 'antd';

import TourTabs from './TourTabs';

import { findIndex } from 'lodash';

import './TourDetail.less';
import moment from 'moment';
import TranslateButton from '../../../common/component/TranslateButton';
import { TOUR_TICKET_CHECK_SUCCESS } from '../../../../../constants/Types';

let permissionActions = [];
const defaultState = {
    action: DETAIL_ACTIONS.CREATE,
    isSubmit: false,
    isGetItem: false,
    validation: {},
    validateTabContent: [],
    activeTab: TOUR_TABS.TOUR_INFO.id,
};

export default class TourDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            tour: clone(this.props.tourState.detail.tour),
            tourLines: clone(this.props.tourState.detail.tourLines),
            tourLineParams: this.props.tourState.detail.tourLineParams,
            uploadStack: [],
            changedDetail: false,
            changedTourLine: false,
            tourLineTickets: [],
            listProperties: [],
            isShowBulkCreate: false,
            isChangeTags: false
        };
    }

    componentDidMount() {
        this.props.onListAllProperties();
        this.initDetail();
        permissionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.TOUR);
    }

    componentWillUnmount() {
      
        this.props.setTourDetail(new Tour())
        this.props.setTagBySku([]);
        this.props.setAllTagGroup([]);
    }

    
    componentDidUpdate(prevProps, prevState){
        
        if (this.state.action === DETAIL_ACTIONS.CREATE) {
            if(this.props.tagGroupState.allTagGroups && !isEqual(prevProps.tagGroupState.allTagGroups, this.props.tagGroupState.allTagGroups)){
                const dataTmp = (this.props.tagGroupState.allTagGroups || []).map((item, index) => {
                    return {
                        tagGroup: item,
                        tagList: [],
                        index: index
                    }
                });
                this.setState({_tagSKUs : dataTmp, tagSKUCurrents: cloneDeep(dataTmp)});
            }

            if (this.props.tagGroupDetailState && !isEqual(prevProps.tagGroupDetailState.tagGroupDetails, this.props.tagGroupDetailState.tagGroupDetails)) {
                const {supplierAll} = this.props.supplierState;
                const {supplierId} = this.state.tour;
                const {tagGroupDetails} = this.props.tagGroupDetailState;
                const supplierCode = supplierAll.find(f => f.id === supplierId)?.code;
                const itemTagByCode = this.state.tagSKUCurrents.find(item => item.tagGroup.code === supplierCode)
                if (itemTagByCode) {
                    let lstArr = [];
                    tagGroupDetails.map(item => {
                        if (itemTagByCode.tagGroup.id === item.tagGroupId) {
                            this.onAddTagToGroupWhenSelectSupplier([item.id], tagGroupDetails, itemTagByCode.index)
                            if (tagGroupDetails.length > 0) {
                                let result;
                                ([item.id] || []).map((item) => {
                                    const tagSelect = tagGroupDetails.find((i) => i.id === item);
                                    result =  {
                                        id: item,
                                        isInsert: true,
                                        tagI18n: [
                                            {
                                            name: tagSelect.name,
                                            },
                                        ],
                                    };
                                });
                                lstArr.push(result);
                            }
                        }
                    })
                    if (lstArr.length > 0) {
                        this._onAddTagGroup(lstArr, itemTagByCode.index);
                    }
                }
            }
        } 
        else if(this.props.tagGroupDetailState.tagGroupSKU && !isEqual(prevProps.tagGroupDetailState.tagGroupSKU, this.props.tagGroupDetailState.tagGroupSKU)) {
            const dataTmp = (this.props.tagGroupDetailState.tagGroupSKU || []).map((item, index) => {
                return {
                    ...item,
                    tagList: (item.tagList || []).map(item => {return {...item, isInsert: true}}),
                    index: index
                }
            });

            this.setState({_tagSKUs : dataTmp, tagSKUCurrents: cloneDeep(dataTmp)});
        } else if (this.props.supplierState.supplierAll && !isEqual(prevProps.supplierState.supplierAll, this.props.supplierState.supplierAll)) {
            const dataTmp = (this.props.tagGroupDetailState.tagGroupSKU || []).map((item, index) => {
                return {
                    ...item,
                    tagList: (item.tagList || []).map(item => {return {...item, isInsert: true}}),
                    index: index
                }
            });
            if (this.state.tour.supplierId) {
                this.setNewDataForTagSKU(this.state.tour.supplierId, dataTmp, this.props.supplierState.supplierAll);
                return;
            }
        }
    }

    onAddTagToGroupWhenSelectSupplier = (value, tags, index) => {
        let tmpArr = [];
        if (tags.length > 0) {
            tmpArr = (value || []).map((item) => {
                const tagSelect = tags.find((i) => i.id === item);
                return {
                id: item,
                isInsert: true,
                tagI18n: [
                    {
                    name: tagSelect.name,
                    },
                ],
                };
            });
        }
        this._onAddTagGroup(tmpArr, index);
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.action === DETAIL_ACTIONS.CREATE) {
            if (nextProps.tourState.detail.tour.id) {
                this.setState({ tour: new Tour() });
            }
        }

        if (nextProps.tourState.detail.tour && !isEqual(nextProps.tourState.detail.tour, this.props.tourState.detail.tour)) {
            this.setState({ tour: cloneDeep(nextProps.tourState.detail.tour) });
            const tourId = nextProps.tourState.detail.tour.id;
            const tourType = nextProps.tourState.detail.tour.type;
            if (tourId) {
                const isTour = nextProps.tourState.detail.tour.type === 2;
                this.props.getListTourLines(tourId, this.state.tourLineParams, isTour);
                // this.checkBackOnUpdate(nextProps.tourState.detail.tour)
            }

            if (tourType === 7) {
                this.props.getSupplierListAllForVW({productType: tourType});
            }
        }
        if (nextProps.tourState.detail.tourLines && !JSON.stringify(nextProps.tourState.detail.tourLines) !== JSON.stringify(this.props.tourState.detail.tourLines)) {
            this.setState({ tourLines: cloneDeep(nextProps.tourState.detail.tourLines), tourLineParams: nextProps.tourState.detail.tourLineParams });
        }
        if (nextProps.uploadState.file && !isEqual(nextProps.uploadState.file, this.props.uploadState.file)) {
            this.processUploadedFiles(nextProps.uploadState.file, nextProps.uploadState.fieldName);
        }

        if(nextProps && nextProps.property) {
            this.setState({
                listProperties: nextProps.property.allProperties
            })
        }
    }

    getMemberShipTypeEnums() {
        return toArray(CAMPAIGN_ENUM.MEMBER_SHIP_TYPE_TOUR);
    }

    render() {
        const { t, tourState, uploadState, generalState, supplierState, setOpenTourlineBulk, autoTranslateState } = this.props;
        const { isFetching, tourTypes, isTourLineFetching, isTourTypeFetching, isFetchingTicket, detail, tourTicketData, isShowBulkCreate, tagsSKUVW } = tourState;
        const { supplierSelectData, supplierAll } = supplierState;
        const { tourLineDateRanges } = detail;
        const { action, isSubmit, tour, tourLines, validation, validateTabContent, changedDetail, changedTourLine, tourLineParams, _tagSKUs, isChangeTags } = this.state;
        const saveDisabled = (!isChangeTags && !changedDetail && !changedTourLine && !this.checkDifferentSlide(tour.slideShowImages,tourState.detail.tour.slideShowImages)) || (permissionActions && !permissionActions.allowUpdate);
        const { provinces } = generalState;
        const tourLineDateRange = tourLineParams ? [tourLineParams.fromDate, tourLineParams.toDate] : []
        const isTranslating = autoTranslateState.tour.isTranslating;

        return (
            <LoadingComponent spinning={isFetching || isSubmit || isTranslating}>
                <PageListComponent className="tour-detail-page">
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'tours'}
                        titleHeader={action === DETAIL_ACTIONS.CREATE
                            ? Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.tour.title')}`).toLowerCase())
                            : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.tour.title')}`.toLowerCase()))
                        }
                        componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                            <TranslateButton
                                languages={tour.translations}
                                current={tour.languageCode}
                                validation={validation.languageCode}
                                onChange={this.onShowTranslate}
                                onClear={this.onExitTranslate}
                                defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                onSelectDefault={language => this.onChangeDetail('languageCode', language.code)}
                                onRemove={this.onRemoveTranslate} />
                        }
                    />
                    <FormActionComponent
                        onSubmit={this.onSubmit}
                        isSubmit={isSubmit}
                        action={action}
                        isGetItem={false}
                        disabledFooter={true}
                    >
                        <TourTabs tour={tour}
                            action={action}
                            activeTab={this.state.activeTab}
                            loading={isFetching || isTourLineFetching || isTourTypeFetching || isFetchingTicket || isTranslating}
                            validation={validation}
                            validateTabContent={validateTabContent}
                            provinces={provinces}
                            tourTypes={tourTypes}
                            tagsSKUVW={tagsSKUVW}
                            tourLines={tourLines}
                            tourTicketData={tourTicketData}
                            supplierSelectData={supplierSelectData}
                            supplierAll={supplierAll}
                            tourLineDateRange={tourLineDateRange}
                            tourLineDateRanges={tourLineDateRanges}
                            saveDisabled={saveDisabled}
                            visibleBtnUpdate={permissionActions && !permissionActions.allowUpdate}
                            onClickBack={this.onClickBack}
                            onChangeDetail={this.onChangeDetail}
                            onChangeDeparture={this.onChangeDeparture}
                            uploadingField={uploadState.fieldName}
                            onUploadImage={this.onUploadImages}
                            onRemoveImage={this.removeImages}
                            onChangeActiveTab={activeTab => this.setState({ activeTab })}
                            onChangeTourLineDateRange={this.onChangeTourLineDateRange}
                            onChangeTourLineTicketFilter={this.onChangeTourLineTicketFilter}
                            onCreateTourLine={this.onCreateTourLine}
                            onSaveTourLine={this.onSaveTourLine}
                            onRemoveTourLine={this.onRemoveTourLine}
                            onBulkUpdateTourLines={this.onBulkUpdateTourLines}
                            onBulkDeleteTourLines={this.onBulkDeleteTourLines}
                            onCreateTourType={this.props.createTourType}
                            onUpdateTourType={this.props.updateTourType}
                            onDeleteTourType={this.onDeleteTourType}
                            onCreateTagSKUVW={this.props.createTagSKUVW}
                            onUpdateTagSKUVW={this.props.updateTagSKUVW}
                            onDeleteTagSKUVW={this.props.deleteTagSKUVW}
                            getItemTicket={this.props.getItemTicket}
                            onInitTickets={this.onInitTickets}
                            onListAllProperties={this.props.onListAllProperties}
                            listProperties={this.state.listProperties}
                            isShowBulkCreate={isShowBulkCreate}
                            showBulkCreate={setOpenTourlineBulk}
                            getDetailTourTicket={this.props.getDetailTourTicket}
                            onChangeMemberShip={this.onChangeMemberShip}
                            onChangeOrderSlide={this.onChangeOrderSlide}
                            //tags
                            _tagSKUs={_tagSKUs}
                            tagGroupDetailState={this.props.tagGroupDetailState}
                            _loadDataTagGroup={this._loadDataTagGroup}
                            _onAddTagGroup={this._onAddTagGroup}
                        />
                    </FormActionComponent>
                </PageListComponent>
            </LoadingComponent>
        );
    }

    initDetail() {
        
        const { match, tourState } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id;
            this.setState({ action: "UPDATE" });
            const tour = find(tourState.tours, t => t.id === id);
            if (tour) this.setState({ tour });
            this.props.getTourDetail(id);
            this.props.getListTourLines(id, this.state.tourLineParams, false);
            this.setDefaultTab()
            this.props.getTagBySku(match.params.id);
        }else{
            this.props.getAllTagGroup();
        }
        this.props.getAllTourTypes();
        this.props.getProvinces();
        this.props.getAllTagSKUVW();
        // this.props.getSupplierSelectList();
    }

    _loadDataTagGroup = (id)=> {
        const { tour } = this.state;
        this.props.getTagInTagroup({
            tagGroupId: id,
            languageCode: tour.languageCode || 'vi-VN'
        });
    }

    _onAddTagGroup = (value, index)=> {
        const _tagSKUs = cloneDeep(this.state._tagSKUs);
        if(_tagSKUs.length > 0){
            // _tagSKUs[index].tagList = value;
            _tagSKUs.map(item => {
                if (item.index === index) item.tagList = value;
            })
            this.setState({ _tagSKUs })
            this._isChangeTag(_tagSKUs);
        }
    }

    _isChangeTag = (_tagSKUs)=>{
        const { tagSKUCurrents } = this.state;
        _tagSKUs = _tagSKUs || this.state._tagSKUs;
        const isChangeTags = !isEqual(_tagSKUs, tagSKUCurrents)
        this.setState({ isChangeTags });
        return isChangeTags;
    }

    // For Case create new Product
    getDataSKUFromProps = () => {
        return (this.props.tagGroupState.allTagGroups || []).map((item, index) => {
            return {
                tagGroup: item,
                tagList: [],
                index: index
            }
        });
    }

    setNewDataForTagSKU = (supplierId, dataSKUs, supplierAll) => {
        const supplierCode = supplierAll.find(f => f.id === supplierId)?.code;
        
        const _tagSKUData = cloneDeep(dataSKUs);
        const getItemTagByCode = _tagSKUData.find(item => item.tagGroup.code ===supplierCode)
        if (getItemTagByCode) {
            this._loadDataTagGroup(getItemTagByCode.tagGroup.id);
        }

        // remove all SKUs with type === 3
        const tagSKUResult = _tagSKUData.filter(tag => {
            if (tag.tagGroup.type !== 3) return tag; 
            if (tag.tagGroup.type === 3 && tag.tagGroup.code ===supplierCode) {
                tag.tagGroup.name = "Dịch vụ";
                return tag;
            }
        })
        this.setState({_tagSKUs: tagSKUResult, tagSKUCurrents: cloneDeep(dataSKUs)});
    }

    onChangeOrderSlide = (e) => {
        let params = Func.getValueForm(e);
        const tour = this.state.tour || {};
        tour[params.name] = params.value
        this.setState({ tour, isSubmit: false });
    }

    onChangeDetail = (fieldName, value) => {
        const tour = this.state.tour;
        const {supplierAll} = this.props.supplierState;
        tour[fieldName] = value;
        if(fieldName === 'objectType'){
            if(value === 'ALL'){
                this.onChangeMemberShip([]);
            }
        }

        // value === 7: Product Type for Vinwonder New
        if(fieldName === 'type' && value === 7){
            if (supplierAll.length <= 0) this.props.getSupplierListAllForVW({productType: value});
            if (this.state.tour.supplierId) {
                this.setNewDataForTagSKU(this.state.tour.supplierId, this.getDataSKUFromProps(), supplierAll);
            }
        }


        if(fieldName === 'type' && value !== 7){
            const dataTmp = (this.props.tagGroupState.allTagGroups || []).map((item, index) => {
                return {
                    tagGroup: item,
                    tagList: [],
                    index: index
                }
            });
            this.setState({_tagSKUs: dataTmp});
        }

        if(fieldName === 'supplierId'){
            this.setNewDataForTagSKU(value, this.getDataSKUFromProps(), supplierAll);
        }

        this.setState({ tour });
        this.isChangedTourDetail(tour);
    };

    onChangeMemberShip = (list) => {
        const getSelectedValue = item => item.value;
        const allOptions = this.getMemberShipTypeEnums().map(getSelectedValue)
        const memberShipTypes = isEqual(allOptions, list) ? this.getMemberShipTypeEnums(true).map(getSelectedValue) : list
        const newData = Object.assign(this.state.tour, { memberShipTypes })
        this.setState({ tour: newData })
        this.isChangedTourDetail(newData);
    };

    onSubmit = (e) => {
        e.preventDefault();
        let updatedDetail = false;
        if (this.isChangedTourDetail() || this._isChangeTag) {
            updatedDetail = this.onUpdateTourDetail();
        }
        if (updatedDetail && this.isChangedTourLine()) {
            this.onUpdateAllTourLine();
        }
    };

    onClickBack = (force) => {
        const { t } = this.props;
        const tour = this.state.tour;
        const { confirm } = Modal;
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else if (this.isChangedTourDetail(tour) && !force) {
            confirm({
                title: t(`notification.unsaveUpdate`),
                content: t(`notification.confirmBack`),
                okText: t(`action.back`),
                cancelText: t(`action.cancel`),
                onOk: () => {
                    this.props.history.push(PATHS.TOUR.LIST.path);
                },
            });
        } else {
            this.props.history.push(PATHS.TOUR.LIST.path);
        }
    }

    onInitTickets = (tickets) => {
        this.setState({ tourLineTickets: tickets })
    }

    onShowTranslate = (language) => {
        const { tour } = this.state;
        tour.setTranslate(language.code);
        tour.setData();
        this.setState({ tour, action: DETAIL_ACTIONS.TRANSLATE });
    }

    onExitTranslate = () => {
        const tour = cloneDeep(this.state.tour);
        const action = DETAIL_ACTIONS[tour.id ? 'UPDATE' : 'CREATE'];
        tour.setTranslate(undefined, true);
        tour.setData();
        this.setState({ tour, action });
    }

    onSaveTranslate = () => {
        const { tour } = this.state;
        const translateFunction = tour.translate.id ? this.props.updateTourTranslate : this.props.createTourTranslate;
        translateFunction(tour, tour.languageCode);
        this.onExitTranslate();
    }

    onRemoveTranslate = (language) => {
        const { tour } = this.state;
        tour.setTranslate(language.code);
        this.props.deleteTourTranslate(tour, { id: tour.id });
    }

    validate() {
        const { t } = this.props;
        const { tour } = this.state;
        let validate = {
            minLength: {
                channel: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.channel`)),
                tourTypes: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.tourTypes`)),
                productTypes: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.productTypes`)),
                // tripItinerary: Func.formatValidation(t('validation.statusCode.code.13'), `${tour.lengthOfTour} ${t(`item.tour.tripItinerary`)}`),
                slideShowImages: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.slideShowImages`)),
                memberShipTypes: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.memberShipTypes`)),
            },
            maxValueNumber: {
                adultSalePrice: Func.formatValidation(t('validation.statusCode.code.8'), t(`item.tour.adultOriginalPrice`)),
                childSalePrice: Func.formatValidation(t('validation.statusCode.code.8'), t(`item.tour.childOriginalPrice`)),
            },
            // maxLength: {
            //     shortDescription: Func.formatValidation(t('validation.statusCode.code.4'), VALIDATE_ENUM.MAX_LENGTH.SHORT_DESCRIPTION)
            // },
            required: {
                tourName: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.tourName`)),
                // departure: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.departure`)),
                destination: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.destination`)),
                adultOriginalPrice: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.adultOriginalPrice`)),
                // highlight: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.highlight`)),
                // description: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.description`)),
                // cancellationPolicy: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.cancellationPolicy`)),
                thumbImage: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.thumbImage`)),
                productTypes: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.productTypes`)),
                shortDescription: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.shortDescription`)),
                type: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.type`)),
                // effectiveStartDate: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.effectiveDate`)),
                // cutOffDate: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.cutOffDate`)),
            },
        };
        if (this.state.action === DETAIL_ACTIONS.CREATE) {
            validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
        }
        if (this.state.tour.isWebsitePublished) {
            validate.required.saleStartDate = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.saleDate`));
            this.state.tour.type !== 7 && (validate.required.stayStartDate = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.stayDate`)));
        }
        if(this.state.tour.installmentFee || this.state.tour.installmentLimit) {
            validate.required.installmentFee = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.installmentFee`))
            validate.required.installmentLimit = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.installmentLimit`))
        }

        if(this.state.tour.type === 7) {
            validate.required.supplierId = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.supplierRequired`))
        }

        if(this.state.tour.type !== 7) { // ======> VinWonder validate
            validate.required.lengthOfTour = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.lengthOfTour`))
            validate.required.effectiveStartDate = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.effectiveDate`))
            validate.required.cutOffDate = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.cutOffDate`))
        }

        if(this.state.tour.type === 1) { // ======> Voucher validate
            validate.required.voucherBookingPeriod = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.voucherBookingPeriod`))
        }
        if(this.state.tour.type === 2) { // ======> Tour validate
            validate.required.bookingPeriod = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.bookingPeriod`))
        }
        let valueValidate = {
            minLength: {
                channel: 1,
                tourTypes: 1,
                productTypes: 1,
                // tripItinerary: tour.lengthOfTour,
                slideShowImages: 1,
                memberShipTypes: this.state.tour.objectType === 'MEMBER' ? 1 : 0
            },
            // maxLength: { shortDescription: VALIDATE_ENUM.MAX_LENGTH.SHORT_DESCRIPTION },
            maxValueNumber: {
                adultSalePrice: tour.adultOriginalPrice,
                childSalePrice: tour.childOriginalPrice,
            }
        };
        const result = Func.multipleValidate(tour, validate, valueValidate);
        if (this.state.tour.tripItinerary.length && !result.tripItinerary) {
            const tripValidate = [];
            this.state.tour.tripItinerary.forEach((trip, index) => {
                if (!trip.title) {
                    tripValidate[index] = Func.messageValidator(true, String(index), Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.tourTitle`)))[index]
                }
            })
            if (tripValidate.length) result.tripItinerary = tripValidate;
        }
        this.setState({ validation: result });
        const validateTabContent = this.validateTabContent();
        return Object.keys(result).length < 1 && validateTabContent;
    }

    validateTabContent = () => {
        let result = []
        let isErrors = 0
        const { t } = this.props;
        const tour = {...this.state.tour}
        let validate = {
            required: {
                title: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.titleContent`)),
                content: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tour.content`))
            },
            maxLength: { title: Func.formatValidation(t('validation.statusCode.code.4'), 50) },
        };
        let valueValidate = {
            maxLength: { title: 50 }
        };
        tour.extraInfos.forEach((info, index) => {
            const resultInfo = Func.multipleValidate(info, validate, valueValidate, true);
            if(Object.keys(resultInfo).length > 0) {
                isErrors++
            }
            result.push(resultInfo)
        })
        const uniqTour = uniqBy(tour.extraInfos, 'title')
        if(tour.extraInfos.length > uniqTour.length) {
            isErrors++
            message.error('Tiêu đề bài viết không được trùng !')
            return false
        }
        this.setState({ validateTabContent: result });
        return isErrors === 0
    }

    processUploadedFiles(fileObj, fieldName) {
        const tour = this.state.tour;
        let image = new TourImage({ fileUrl: get(fileObj, 'data.fileUrl'), fileName: get(fileObj, 'data.fileName') })
        if(fieldName === "slideShowImages"){
            image = new TourImage({fileUrl: get(fileObj,'data.fileUrl'), fileName: get(fileObj,'data.fileName'), order: tour.slideShowImages.length})
        }
        if (tour[fieldName] && Array.isArray(tour[fieldName])) {
            let images = tour[fieldName] || [];
            images.push(image);
            tour[fieldName] = images;
        } else {
            tour[fieldName] = image
        }
        let uploadStack = this.state.uploadStack;
        const removeIndex = uploadStack.indexOf(fieldName);
        if (removeIndex >= 0) {
            uploadStack.splice(removeIndex, 1);
            this.setState({ uploadStack })
        }
        this.setState({ tour });
        this.isChangedTourDetail(tour);
        if (!uploadStack.length) this.props.uploadReset();
    }

    onUploadImages = (file, fieldName, imageUrlSlug) => {
        const tour = this.state.tour;
        let fileData = file.target.files;
        if (fileData.length > 6) {
            message.error(Func.formatValidation(i18n.t('validation.statusCode.code.5'), 6));
            return false;
        } else if (((tour[fieldName] && tour[fieldName].length && tour[fieldName].length >= 0 ? tour[fieldName].length : 0) + fileData.length) > 6) {
            message.error(Func.formatValidation(i18n.t('validation.statusCode.code.5'), 6));
            return false;
        } else if (isEmpty(imageUrlSlug)){
            message.error(i18n.t('validation.statusCode.code.INVALID_URL_SLUG'));
            return false;
        }
        let uploadStack = this.state.uploadStack;
        uploadStack = uploadStack.concat(new Array(fileData.length).fill(fieldName));
        this.setState({ uploadStack })
        let imageValidation = ['image/jpeg', 'image/jpg', 'image/png'];
        if(fieldName === "slideShowImages") {
            imageValidation = ['image/jpeg', 'image/jpg', 'image/png', "video/mp4", "video/mov", "video/wmv", "video/flv", "video/3g2", "video/3gp"];
        }
        Object.keys(fileData).map((i) => {
            const fileExtension = fileData[i].name.split(".").at(-1);
            const validateByFileExtension = ['jpeg', 'jpg', 'png', "mp4", "mov", "wmv", "flv", "3g2", "3gp"]
            if (imageValidation.includes(fileData[i].type) || validateByFileExtension.includes(fileExtension)) {
                this.props.uploadFile({ file: fileData[i], directory: UPLOAD_DIRECTORY.TOUR_THUMB, isFile: 2, fieldName, ImageUrlSlug: imageUrlSlug })
            } else {
                message.error(i18n.t('validation.image'))
            }
        })
    }

    removeImages = (url, fieldName) => {
        if (!url) return;
        const { t } = this.props;
        const tour = this.state.tour;
        const { confirm } = Modal;
        const removeImg = () => {
            if (tour[fieldName] && Array.isArray(tour[fieldName])) {
                tour[fieldName] = (tour[fieldName] || []).filter(item => !url.endsWith(item.url));
            } else {
                tour[fieldName] = undefined;
            }
            this.setState({ tour });
            this.isChangedTourDetail(tour);
        }
        confirm({
            title: t(`notification.sureRemove`),
            okText: t(`action.remove`),
            cancelText: t(`action.cancel`),
            onOk: removeImg,
        });
    };

    onSaveTourLine = (tourLine, index) => {
        const tour = this.props.tourState.detail.tour
        if (tourLine.id) {
            this.props.updateTourLine(tourLine, this.props.tourState.detail.tourLineParams, tour)
        } else {
            const { tourLineTickets } = this.state;
            if(tourLineTickets.length > 0) {
                const dataTourLine = {...tourLine, tickets: tourLineTickets, tourTicketItemIds: tourLineTickets }
                this.props.createTourLine(dataTourLine, this.props.tourState.detail.tourLineParams, tour)
                return
            }
            message.error(i18n.t('validation.tourLineTicketNull'))
        }
    }

    onRemoveTourLine = (tourLine, index) => {
        const { tour } = this.props.tourState.detail;
        if (tourLine.id) {
            this.props.deleteTourLine(tourLine, this.props.tourState.detail.tourLineParams, tour);
        } else if (index >= 0) {
            this.setState({ tourLines: this.state.tourLines.filter((t, i) => i !== index) })
        }
    }

    onBulkUpdateTourLines = (tourLineBulk) => {
        this.props.updateTourLinesBulk(tourLineBulk, this.state.tourLineParams);
    }

    onBulkDeleteTourLines = (tourLines) => {
        this.props.deleteTourLinesBulk(tourLines, this.state.tourLineParams);
    }

    onUpdateTourDetail() {
        if (this.validate()) {
            this.updateTourDetail();
            return true;
        } else {
            message.error(this.props.t('validation.checkForm'));
            return false;
        }
    }

    onUpdateAllTourLine() {
        const tourLines = this.state.tourLines;
        const originalData = this.props.tourState.detail.tourLines;
        tourLines.forEach((tourLine, index) => {
            if (index >= originalData.length) {
                this.props.createTourLine(tourLine);
            } else if (tourLine.id === originalData[index].id && !isEqual(tourLine, originalData[index])) {
                this.props.updateTourLine(tourLine)
            } else {
            }
        })
    }

    onChangeTourLineDateRange = (dateRange = []) => {
        const { tour } = this.state;
        const params = {
            ...this.state.tourLineParams,
            fromDate: dateRange[0].startOf('month').add(1, 'days'),
            toDate: dateRange[1].endOf('month'),
        }
        this.setState({ tourLineParams: params })
        this.props.getListTourLines(tour.id, params, tour.type === 2);
    }

    onChangeTourLineTicketFilter = (tourTicketId) => {
        const { tour } = this.state;
        const params = {
            ...this.state.tourLineParams,
        }
        delete params.tourItemId;
        delete params.tourTicketId;
        if (tourTicketId === 'ALL') {
            delete params.tourTicketIds;
        } else {
            params.tourTicketIds = tourTicketId;
        }
        this.setState({ tourLineParams: params })
        this.props.getListTourLines(tour.id, params, tour.type === 2);
    }

    checkBackOnUpdate = (newTour) => {
        const { action } = this.state;
        if (action === 'CREATE' && !!newTour.id) {
            this.onClickBack(true)
        }
    }

    onCreateTourLine = (isBulk = false, tourLineBulkorTourLine) => {
        const { tourLines, tour, tourLineTickets } = this.state;
        if (isBulk) {
            if (tourLineBulkorTourLine) {
                const selectedTickets = tourLineBulkorTourLine.tourTicketItemIds || tourLineTickets;
                if(selectedTickets.length > 0) {
                    const dataBulkTouline = {...tourLineBulkorTourLine, tickets: selectedTickets, tourTicketItemIds: selectedTickets }
                    this.props.createTourLinesBulk(dataBulkTouline, this.state.tourLineParams);
                    return
                }
                message.error(i18n.t('validation.tourLineTicketNull'))
            }
        } else {
            let departureDate = tourLineBulkorTourLine && tourLineBulkorTourLine.departureDate && tourLineBulkorTourLine.departureDate.toISOString();
            if (moment(departureDate).isBefore(moment())) {
                departureDate = moment().toISOString();
            }
            tourLines.push(new TourLine({ tourId: tour.id, departureDate }));
            this.setState({ tourLines })
        }
    }

    onChangeDeparture = (tourLineIndex, fieldName, value) => {
        const { tourLines } = this.state;
        tourLines[tourLineIndex][fieldName] = value;
        this.setState({ tourLines })
    }

    onDeleteTourType = (tourType) => {
        const { tour } = this.props.tourState.detail;
        const selectedTypeIndex = findIndex(tour.tourTypes, type => type.id === tourType.id);
        tour.tourTypes = tour.tourTypes.filter(type => type.id !== tourType.id);
        this.props.deleteTourType(tourType, selectedTypeIndex >= 0 ? { tour } : undefined)
    }

    updateTourDetail() {
        const { tour, action, _tagSKUs } = this.state;
        const { match } = this.props;
        let skuTags = {};
        let tourReq = tour;
        if(tourReq.type === 1){//voucher
            tourReq['bookingPeriod'] = undefined;
        }
        if(tourReq.type === 2){ //tour
            tourReq['voucherBookingPeriod'] = undefined;
        }
        if(tourReq.type === 7){ //vin wonder
            tourReq['stayStartDate'] = undefined;
            tourReq['effectiveStartDate'] = undefined;
            tourReq['voucherBookingPeriod'] = undefined;
            tourReq['cutOffDate'] = undefined;
            tourReq['bookingPeriod'] = undefined;
            tourReq['lengthOfTour'] = undefined;
        } else {
            tourReq['supplierId'] = undefined;
        }
        if(_tagSKUs && _tagSKUs.length > 0){
            let lstInserts = [];
            let lstDeletes = [];
            _tagSKUs.map(item => {
                if(item.tagList){
                    (item.tagList || []).map(it => {
                        if(it.isInsert){
                            lstInserts.push(it.id)
                        }else{
                            lstDeletes.push(it.id)
                        }
                    });
                }
            })
            skuTags = {
                skuId: match.params.id,
                inserts: lstInserts,
                deletes: lstDeletes,
                type: 2
            }
        }
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onSaveTranslate()
        } else {
            const actionFunction = action === 'CREATE' ? this.props.createTour : this.props.updateTour;
            actionFunction({tour: tourReq, skuTags: skuTags});
        }
    }

    isChangedTourDetail(tour) {
        tour = tour || this.state.tour;
        const { tourState } = this.props;
        const changedDetail = tourState.detail.tour && !isEqual(tourState.detail.tour, tour)
        this.setState({ changedDetail });
        return changedDetail;
    }

    isChangedTourLine(tourLines) {
        tourLines = tourLines || this.state.tourLines;
        const { tourState } = this.props;
        const changedTourLine = tourState.detail.tourLines && this.state.tourLines.length && !isEqual(tourState.detail.tourLines, tourLines);
        this.setState({ changedTourLine });
        return changedTourLine;
    }

    setDefaultTab(){
        const hash = String(this.props.location.hash).replace('#', '')
        const defaultTab = find(toArray(TOUR_TABS), item => item.id === hash)
        if(defaultTab){
            this.setState({ activeTab: defaultTab.id }) 
        }
    }

    checkDifferentSlide(arr1, arr2) {
        for (let i = 0; i < arr1.length; i++) {
            if(arr1[i].name !== arr2[i].name){
                return true;
            }
        }
        return false
    }

}
